// extracted by mini-css-extract-plugin
export default {"currentDate":"CurrentDayDisplay_currentDate__fzfyD"};